import { forEach, has, keyBy, reduce } from 'lodash'

import results from './results'

const resultLabels = keyBy(results, (r) => r.label.toLowerCase())

const str = (s) => s.toLowerCase().replace(/[^\w\s]/g, 'i')

const sorter = (greater, lesser) => (greater > lesser ? -1 : 1)

const byAlpha = (a, b) => sorter(a.value, b.value)
const byMismatch = (a, b) => sorter(b.mismatch, a.mismatch)
const byIsLabel = (a, b) => sorter(a.isLabel, b.isLabel)
const byWeight = (a, b) => sorter(a.weight, b.weight)

/**
 * This fn sorts the list of string values according to how like the target they are
 * @param {string} target
 * @param {array} values
 * @param {number} minWeight
 * @returns
 */
const weightedSort = (target, values, minWeight) => {
  const A = str(target)
  const results = []
  const getWeights = (value) => {
    const weight = new RegExp(A, 'g').test(value) ? 100 : 0
    const isLabel = has(resultLabels, value)
    const B = str(value)
    if (weight < minWeight) {
      return
    }
    const setA = new Set(A)
    const mismatch = reduce(
      B,
      (n, letter) => {
        return setA.has(letter) ? n : n + 1
      },
      0,
    )
    results.push({
      weight,
      mismatch,
      value,
      isLabel,
    })
  }
  forEach(values, getWeights)
  return results.sort(byAlpha).sort(byIsLabel).sort(byMismatch).sort(byWeight)
}

export default weightedSort
